import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/networkHandler';
import { tokenConfig } from '../tokenConfig';

// Fetch Top Board
export const getTopBoard = createAsyncThunk(
  'dashboard/top-board',
  async ({ campaignObj }, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      let params = '';
      if (campaignObj) {
        params += `campaignObj=${encodeURIComponent(campaignObj)}`;
      }
      const response = await axios.get(`/dashboard/top-board?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);


// Fetch Campaign Analytic
export const getAnalytics = createAsyncThunk(
    'dashboard/campaign-analytics',
    async (_, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.get('/dashboard/campaign-analytics', config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

  // Fetch Audience Reach
export const getAudienceReach = createAsyncThunk(
    'dashboard/audience-reach',
    async (_, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        const response = await axios.get('/dashboard/audience-reach', config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

const overviewSlice = createSlice({
  name: 'overview',
  initialState: {
    loadingTop: false,
    topboard: {},
    analytics: [],
    audienceReach: {},
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTopBoard.pending, (state) => {
        state.loadingTop = true;
        state.error = null;
      })
      .addCase(getTopBoard.fulfilled, (state, action) => {
        state.loadingTop = false;
        state.topboard = action.payload.data;
      })
      .addCase(getTopBoard.rejected, (state, action) => {
        state.loadingTop = false;
        state.error = action.payload?.message || 'An error occurred';
      })

      // Fetch Analytics
      builder
       .addCase(getAnalytics.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
       .addCase(getAnalytics.fulfilled, (state, action) => {
          state.loading = false;
          state.analytics = action.payload.data;
        })
       .addCase(getAnalytics.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload?.message || 'An error occurred';
        })

        // Fetch Audience Reach
        builder
       .addCase(getAudienceReach.pending, (state) => {
         state.loading = true;
          state.error = null;
        })
       .addCase(getAudienceReach.fulfilled, (state, action) => {
         state.loading = false;
          state.audienceReach = action.payload.data;
        })
       .addCase(getAudienceReach.rejected, (state, action) => {
         state.loading = false;
          state.error = action.payload?.message || 'An error occurred';
        });
  },
});

export default overviewSlice.reducer;
